import React from "react";
import "./Arrow.css";

export const Arrow = () => (
  <div className="arrow-wrapper">
    <div className="arrow" />
  </div>
);
